// extracted by mini-css-extract-plugin
module.exports = {"Smartphone":"Smartphone_Smartphone__3XF8Y","Content":"Smartphone_Content__3zJmE"};